import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import { Dialog } from '@linktivity/link-ui';
import { buildLocalizedPath, buildPathWithRedirect } from '@link/share/utils';
import { trackGa4Login } from '@link/share/vendors';
import Login from '@link/share/views/Login';
import { IDialogLoginProps } from './DialogLogin.types';

const DialogLogin = observer(
  ({
    visible,
    onClose,
    auth,
    firebase,
    loginMethods,
    onLoginSuccess
  }: IDialogLoginProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      if (visible && auth.loggedIn) {
        onLoginSuccess?.();
      }
    }, [visible, auth.loggedIn, onLoginSuccess]);

    // An email sign-in still lacking ARS tokens needs the OTP: verify on the
    // email-verification page like the login page does, then return here.
    // With tokens it stays, and onLoginSuccess continues on this page.
    const handleAuthSuccess = useCallback(
      (_redirectTo: string, isNewUser: boolean) => {
        if (auth.loggedIn) {
          // No verification page follows: this code-less exchange is the sign-in.
          trackGa4Login('email', isNewUser ? 'created' : 'existing', 'no');
          return;
        }
        navigate(
          buildPathWithRedirect(
            buildLocalizedPath('email-verification'),
            location.pathname + location.search
          ),
          { state: { isNewUser, autoResendOtp: true } }
        );
      },
      [auth, navigate, location.pathname, location.search]
    );

    return (
      <Dialog visible={visible} onClose={onClose}>
        {/* Product pages open it only to gate an order. */}
        <Login
          auth={auth}
          firebase={firebase}
          loginMethods={loginMethods}
          onAuthSuccess={handleAuthSuccess}
          ga4Entry="checkout_gate"
        />
      </Dialog>
    );
  }
);

export default DialogLogin;
